/**
 * Le symbole de marque : le « $ » du favicon.
 *
 * Le glyphe est repris tel quel de `public/favicon.svg` et de
 * `apple-touch-icon.svg` — l'icône de l'onglet, celle de l'écran d'accueil et
 * celle de l'application ne peuvent pas raconter trois choses différentes.
 *
 * Le fond n'est pas dessiné ici : le symbole se pose sur la pastille de son
 * hôte (`.rail-brand`), dont le dégradé suit le thème actif. Le favicon, lui,
 * est figé en bleu — un fichier statique ne connaît pas le thème choisi.
 */
interface BrandMarkProps {
  /**
   * Côté du symbole, en pixels. Le défaut remplit la pastille de 40 px du
   * rail dans les proportions du favicon, sans en toucher les bords.
   */
  size?: number;
  className?: string;
}

export default function BrandMark({ size = 30, className }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      aria-hidden
    >
      <text
        x="32"
        y="47"
        textAnchor="middle"
        fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif"
        fontSize="46"
        fontWeight="800"
        fill="currentColor"
      >
        $
      </text>
    </svg>
  );
}
